import { useAtom } from 'jotai'

import { applicationRequestStore } from 'src/stores'

export const useApplicationRequestStore = () => {
  const [applicationRequestStoreValue, setApplicationRequestStoreValue] = useAtom(
    applicationRequestStore.state
  )

  const setTargetApplicationRequestValues = (input: {
    projectId: string
    applicationId: number
    applicationStepId: number
    isProxy?: boolean
  }) => {
    setApplicationRequestStoreValue({
      targetProjectId: input.projectId,
      targetApplicationId: input.applicationId,
      targetApplicationStepId: input.applicationStepId,
      isProxy: input.isProxy,
    })
  }

  const resetTargetApplicationRequestValues = () => {
    setApplicationRequestStoreValue({
      targetProjectId: undefined,
      targetApplicationId: undefined,
      targetApplicationStepId: undefined,
      isProxy: undefined,
    })
  }

  return {
    targetProjectId: applicationRequestStoreValue.targetProjectId,
    targetApplicationId: applicationRequestStoreValue.targetApplicationId,
    targetApplicationStepId: applicationRequestStoreValue.targetApplicationStepId,
    isProxy: applicationRequestStoreValue.isProxy,
    setTargetApplicationRequestValues,
    resetTargetApplicationRequestValues,
  }
}
